import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";
import { createSelector } from "reselect";
import axios from "../../utills/api";
import html2canvas from "html2canvas";

const ProfileDropdown = () => {
  const profiledropdownData = createSelector(
    (state) => state.Profile,
    (user) => user?.user
  );

  const user = useSelector(profiledropdownData);

  const [userName, setUserName] = useState("");
  const [profileImage, setProfileImage] = useState("");
  const [isProfileDropdown, setIsProfileDropdown] =
    useState(false);

  const toggleProfileDropdown = () =>
    setIsProfileDropdown(!isProfileDropdown);

  const IMAGE_BASE_URL =
    window.location.hostname === "localhost"
      ? "http://localhost:5000"
      : "";

  // ==============================
  // GET INITIALS
  // ==============================

  const getInitials = (name = "") => {
    if (!name) return "AD";

    const words = name.trim().split(" ");

    if (words.length >= 2) {
      return (
        words[0][0] +
        words[words.length - 1][0]
      ).toUpperCase();
    }

    return name.substring(0, 2).toUpperCase();
  };

  // ==============================
  // FETCH PROFILE
  // ==============================

  const fetchProfile = async () => {
    try {
      const res = await axios.get(
        "/property-profile"
      );

      if (res.data?.client) {
        setUserName(
          res.data.client.adminName ||
            res.data.client.name ||
            ""
        );

        setProfileImage(
          res.data.client.profileImage || ""
        );
      }
    } catch (err) {
      console.error(
        "Failed to load profile:",
        err
      );
    }
  };

  // ==============================
  // LOAD USER + PROFILE
  // ==============================

  useEffect(() => {
    const authUser =
      sessionStorage.getItem("authUser") ||
      localStorage.getItem("user");

    if (authUser) {
      try {
        const obj = JSON.parse(authUser);

        setUserName(
          obj.name ||
            obj.username ||
            obj?.user?.name ||
            ""
        );
      } catch (e) {
        console.error(
          "Failed to parse user data",
          e
        );
      }
    }

    fetchProfile();
  }, []);

  // ==============================
  // GENERATE GUEST QR CODE
  // ==============================

  const generateGuestQRCode = async () => {
    try {
      const res = await axios.get(
        "/qr/guest-qr"
      );

      if (!res.data?.qrImage) return;

      const container =
        document.createElement("div");

      container.style.width = "794px";
      container.style.height = "1123px";
      container.style.background = "#ffffff";
      container.style.display = "flex";
      container.style.flexDirection = "column";
      container.style.justifyContent = "center";
      container.style.alignItems = "center";
      container.style.padding = "60px";
      container.style.boxSizing = "border-box";
      container.style.position = "fixed";
      container.style.left = "-99999px";

      // Property Name

      const authUser =
        JSON.parse(
          sessionStorage.getItem("authUser")
        );

      const propertyName =
        authUser?.user?.name ||
        authUser?.data?.user?.name ||
        authUser?.data?.name ||
        authUser?.name ||
        "YatraNest";

      // ==============================
      // TITLE
      // ==============================

      const title =
        document.createElement("h1");

      title.innerText = propertyName;
      title.style.fontSize = "42px";
      title.style.fontWeight = "700";
      title.style.marginBottom = "40px";
      title.style.color = "#198754";
      title.style.textAlign = "center";

      // ==============================
      // QR IMAGE
      // ==============================

      const qr =
        document.createElement("img");

      qr.src = res.data.qrImage;

      qr.style.width = "420px";
      qr.style.height = "420px";
      qr.style.objectFit = "contain";

      // ==============================
      // HEADING
      // ==============================

      const heading =
        document.createElement("h2");

      heading.innerText =
        "Scan Here To Access Your Stay Details & Guest Services";

      heading.style.marginTop = "50px";
      heading.style.fontSize = "34px";
      heading.style.textAlign = "center";
      heading.style.color = "#198754";
      heading.style.lineHeight = "1.5";
      heading.style.fontWeight = "700";

      // ==============================
      // DESCRIPTION
      // ==============================

      const sub =
        document.createElement("p");

      sub.innerText =
        "Leave your luggage at reception and relax — our hospitality team will take care of the rest and deliver everything comfortably to your room.";

      sub.style.marginTop = "25px";
      sub.style.fontSize = "22px";
      sub.style.textAlign = "center";
      sub.style.color = "#6c757d";
      sub.style.lineHeight = "1.8";
      sub.style.maxWidth = "650px";

      // ==============================
      // FOOTER
      // ==============================

      const footer =
        document.createElement("div");

      footer.innerText =
        "Powered by YatraNest";

      footer.style.position = "absolute";
      footer.style.bottom = "40px";
      footer.style.fontSize = "18px";
      footer.style.color = "#999";

      // Append

      container.appendChild(title);
      container.appendChild(qr);
      container.appendChild(heading);
      container.appendChild(sub);
      container.appendChild(footer);

      document.body.appendChild(container);

      const canvas =
        await html2canvas(container, {
          scale: 2,
        });

      const image =
        canvas.toDataURL("image/png");

      const link =
        document.createElement("a");

      link.href = image;

      link.download =
        `guest-qr-${res.data.tenantId}.png`;

      document.body.appendChild(link);

      link.click();

      document.body.removeChild(link);

      document.body.removeChild(container);
    } catch (err) {
      console.error(
        "QR Download Error:",
        err
      );
    }
  };

  return (
    <Dropdown
      isOpen={isProfileDropdown}
      toggle={toggleProfileDropdown}
      className="ms-sm-3 header-item topbar-user"
    >
      {/* ==============================
          PROFILE BUTTON
      ============================== */}

      <DropdownToggle
        tag="button"
        type="button"
        className="btn"
      >
        <span className="d-flex align-items-center">

          {profileImage ? (
            <img
              className="rounded-circle header-profile-user"
              src={`${IMAGE_BASE_URL}${profileImage}`}
              alt="Profile"
              style={{
                objectFit: "cover",
              }}
            />
          ) : (
            <div
              className="rounded-circle bg-primary text-white d-flex align-items-center justify-content-center"
              style={{
                width: "32px",
                height: "32px",
                fontSize: "12px",
                fontWeight: "600",
                minWidth: "32px",
              }}
            >
              {getInitials(userName)}
            </div>
          )}

          <span className="text-start ms-xl-2">

            <span className="d-none d-xl-inline-block ms-1 fw-medium user-name-text">
              {userName || "Guest"}
            </span>

            <span className="d-none d-xl-block ms-1 fs-12 text-muted user-name-sub-text">
              {userName ? "Admin" : ""}
            </span>

          </span>

        </span>
      </DropdownToggle>

      {/* ==============================
          DROPDOWN MENU
      ============================== */}

      <DropdownMenu
        className="dropdown-menu-end"
        style={{
          minWidth: 260,
        }}
      >
        <div className="px-2 py-2">

          {/* WELCOME */}

          <div className="px-2 py-2">
            <h6 className="mb-0 fw-semibold">
              Welcome {userName || "Admin"}!
            </h6>

            <small className="text-muted">
              Manage your account settings
            </small>
          </div>

          <div className="dropdown-divider" />

          {/* ==============================
              PROFILE SETTINGS
          ============================== */}

          <DropdownItem
            tag={Link}
            to="/profile"
            className="d-flex align-items-center"
          >
            <div
              className="d-flex align-items-center justify-content-center me-2"
              style={{
                width: "34px",
                height: "34px",
                borderRadius: "8px",
                backgroundColor:
                  "rgba(13, 110, 253, 0.1)",
              }}
            >
              <i
                className="ri-settings-3-line"
                style={{
                  fontSize: "18px",
                  color: "#0d6efd",
                }}
              />
            </div>

            <div>
              <div className="fw-medium">
                Profile Settings
              </div>

              <small className="text-muted">
                Manage your profile
              </small>
            </div>

          </DropdownItem>

          <div className="dropdown-divider" />

          {/* ==============================
              GENERATE QR
          ============================== */}

          <DropdownItem
            className="d-flex align-items-center"
            onClick={generateGuestQRCode}
            style={{
              cursor: "pointer",
            }}
          >
            <i className="mdi mdi-qrcode fs-18 text-muted me-2" />

            <span>
              Generate Guest QR Code
            </span>

          </DropdownItem>

          {/* ==============================
              LOGOUT
          ============================== */}

          <DropdownItem
            tag={Link}
            to="/logout"
            className="d-flex align-items-center text-danger"
          >
            <i className="mdi mdi-logout fs-18 me-2" />

            <span>
              Logout
            </span>

          </DropdownItem>

        </div>
      </DropdownMenu>

    </Dropdown>
  );
};

export default ProfileDropdown;